// (function () {
//   function FaqAccordion(el) {
//     this.el = el;
//     this.summary = el.querySelector(':scope > summary');
//     this.content = el.querySelector(':scope > .section-faq__answer');
//     this.animation = null;
//     this.isClosing = false;
//     this.isExpanding = false;
//     el._faqAccordion = this;
//     this.summary.addEventListener('click', this.onClick.bind(this));
//   }

//   FaqAccordion.prototype.onClick = function (event) {
//     event.preventDefault();
//     this.el.style.overflow = 'hidden';

//     if (this.isClosing || !this.el.open) {
//       this.closeSiblings();
//       this.open();
//     } else if (this.isExpanding || this.el.open) {
//       this.shrink();
//     }
//   };

//   FaqAccordion.prototype.closeSiblings = function () {
//     var panel = this.el.closest('.section-faq__panel');
//     if (!panel) return;

//     var items = panel.querySelectorAll(':scope > details[open]');
//     for (var i = 0; i < items.length; i++) {
//       var item = items[i];
//       if (item !== this.el && item._faqAccordion) {
//         item._faqAccordion.shrink();
//       }
//     }
//   };

//   FaqAccordion.prototype.shrink = function () {
//     this.isClosing = true;

//     var startHeight = this.el.offsetHeight + 'px';
//     var endHeight = this.summary.offsetHeight + 'px';

//     if (this.animation) this.animation.cancel();

//     this.animation = this.el.animate({ height: [startHeight, endHeight] }, { duration: 250, easing: 'ease-out' });

//     this.animation.onfinish = this.onAnimationFinish.bind(this, false);
//     this.animation.oncancel = function () {
//       this.isClosing = false;
//     }.bind(this);
//   };

//   FaqAccordion.prototype.open = function () {
//     this.el.style.height = this.el.offsetHeight + 'px';
//     this.el.open = true;
//     window.requestAnimationFrame(this.expand.bind(this));
//   };

//   FaqAccordion.prototype.expand = function () {
//     this.isExpanding = true;

//     var startHeight = this.el.offsetHeight + 'px';
//     var endHeight = this.summary.offsetHeight + this.content.offsetHeight + 'px';

//     if (this.animation) this.animation.cancel();

//     this.animation = this.el.animate({ height: [startHeight, endHeight] }, { duration: 250, easing: 'ease-out' });

//     this.animation.onfinish = this.onAnimationFinish.bind(this, true);
//     this.animation.oncancel = function () {
//       this.isExpanding = false;
//     }.bind(this);
//   };

//   FaqAccordion.prototype.onAnimationFinish = function (open) {
//     this.el.open = open;
//     this.animation = null;
//     this.isClosing = false;
//     this.isExpanding = false;
//     this.el.style.height = '';
//     this.el.style.overflow = '';
//   };

//   function initFaqAccordions(root) {
//     var items = root.querySelectorAll('.section-faq__item:not([data-faq-initialized])');
//     items.forEach(function (el) {
//       new FaqAccordion(el);
//       el.dataset.faqInitialized = 'true';
//     });
//   }

//   function initFaqTabs(root) {
//     var sections = root.querySelectorAll('.section-faq:not([data-tabs-initialized])');
//     sections.forEach(function (section) {
//       var tabs = section.querySelectorAll('.section-faq__tab');
//       tabs.forEach(function (tab) {
//         tab.addEventListener('click', function () {
//           var target = tab.dataset.tabTarget;

//           tabs.forEach(function (t) {
//             t.classList.toggle('is-active', t === tab);
//           });

//           section.querySelectorAll('.section-faq__panel').forEach(function (panel) {
//             panel.classList.toggle('is-active', panel.dataset.tabPanel === target);
//           });
//         });
//       });
//       section.dataset.tabsInitialized = 'true';
//     });
//   }

//   function initFaq(root) {
//     root = root || document;
//     initFaqTabs(root);
//     initFaqAccordions(root);
//   }

//   document.addEventListener('DOMContentLoaded', function () {
//     initFaq(document);
//   });

//   document.addEventListener('shopify:section:load', function (event) {
//     initFaq(event.target);
//   });
// })();



(function () {
  function initFaqTabs(root) {
    var sections = root.querySelectorAll('.section-faq:not([data-tabs-initialized])');
    sections.forEach(function (section) {
      var tabs = section.querySelectorAll('.section-faq__tab');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.dataset.tabTarget;

          tabs.forEach(function (t) {
            t.classList.toggle('is-active', t === tab);
          });

          section.querySelectorAll('.section-faq__panel').forEach(function (panel) {
            panel.classList.toggle('is-active', panel.dataset.tabPanel === target);
          });
        });
      });
      section.dataset.tabsInitialized = 'true';
    });
  }

  function initFaq(root) {
    root = root || document;
    initFaqTabs(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initFaq(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initFaq(event.target);
  });
})();
